const routeConstants = {
  contentSubmissionBase: '/inbound/v2/creator/content-submission',
  productRequestBase: '/inbound/v2/creator/product-request',
  challengesBase: '/inbound/v2/creator/challenges',
  challengeApplicationBase: '/inbound/v2/challenges',
};

const apiRoutes = {
  verifyInboundEnabled: '/inbound',
  checkApplicationExists: '/inbound/v2/exists',
  createInboundApplication: '/inbound/create',
  getInboundBuilderDetails: '/inbound/details',
  getPrimaryInboundFromSubdomain: '/inbound/v2/get-primary-inbound',

  loginCreator: '/inbound/v2/login',
  getResources: '/inbound/creator/resources',
  getCreatorDetails: '/inbound/creator/details',
  updateInfluencerAddress: '/inbound/creator/update-address',
  addInfluencerAddress: '/inbound/creator/add-address',
  updateDiscountCode: '/inbound/creator/update-discount-code',
  changePassword: '/inbound/creator/change-password',
  getLocationDetails: '/inbound/location-details',
  getPaymentHistory: '/inbound/creator/payment-history',
  forgotPassword: '/inbound/creator/password-reset',
  resendForgotPasswordEmail: '/inbound/creator/resend/password-reset-link',
  getCreatorPendingPayments: '/inbound/creator/pending-payments',
  getCreatorCompletedPayments: '/inbound/creator/completed-payments',
  updateCreatorDetails: '/inbound/creator/update-details',
  getCreatorCompletedPaymentsForUGCCreators: '/inbound/v2/creator/content-submission/completed-payments-ugc',

  getProductListInfo: '/inbound/application/product-options',
  getLogPostList: '/inbound/creator/get-log-posts',
  addLogPost: '/inbound/creator/log-post',
  addLogStory: '/inbound/creator/log-story',

  getProductsListInfo: '/inbound/creator/product-list',

  // Usage Rights
  getUsageRights: '/inbound/creator/get-usage-rights',
  updateUsageRights: '/inbound/creator/update-usage-rights-request',
  reviseUsageRights: '/inbound/creator/revise-usage-rights-request',
  getNotifications: '/inbound/creator/notifications',
  updateNotificationStatus: '/inbound/creator/notifications/update-seen-status',

  getContentSubmissionPresignedUrl: `${routeConstants.contentSubmissionBase}/get-presigned-url`,
  getContentSubmissions: `${routeConstants.contentSubmissionBase}`,
  editContentSubmission: `${routeConstants.contentSubmissionBase}`,
  deleteContentSubmission: `${routeConstants.contentSubmissionBase}`,
  getContentComments: `${routeConstants.contentSubmissionBase}/comments`,

  getProductRequestSettings: `${routeConstants.productRequestBase}/settings`,
  getProductRequestedByCreator: `${routeConstants.productRequestBase}`,
  createProductRequest: `${routeConstants.productRequestBase}`,
  getProducts: `${routeConstants.productRequestBase}/products`,

  getNeedsAttentionChallenges: `${routeConstants.challengesBase}/needs-attention`,
  getCompletedChallenges: `${routeConstants.challengesBase}/completed`,
  getCompletedChallengesSummary: `${routeConstants.challengesBase}/completed/summary`,
  challengeReviews: `${routeConstants.challengesBase}/reviews`,

  challengeApplication: routeConstants.challengeApplicationBase,
};

const serverUrl = import.meta.env.VITE_APP_LOCAL_SERVER_URL;

export { apiRoutes, serverUrl };
